import { render } from "./CalendarIcon.vue?vue&type=template&id=bf97d14e&scoped=true"
const script = {}

import "./CalendarIcon.vue?vue&type=style&index=0&id=bf97d14e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf97d14e"]])

export default __exports__